export function normalizeReferralCode(value) {
  return String(value || '').trim().toUpperCase().replace(/[۰-۹٠-٩]/g, digit => {
    const code = digit.charCodeAt(0);
    return String(code >= 0x6f0 ? code - 0x6f0 : code - 0x660);
  });
}

export function buildReferralLink(origin, code) {
  const normalized = normalizeReferralCode(code);
  if (!/^[A-Z0-9]{6}$/.test(normalized)) return '';
  const link = new URL('/Register_page', origin);
  link.searchParams.set('ref', normalized);
  return link.href;
}
